import { render } from "./DisclosureIcon.vue?vue&type=template&id=924aad52&scoped=true"
import script from "./DisclosureIcon.vue?vue&type=script&lang=js"
export * from "./DisclosureIcon.vue?vue&type=script&lang=js"

import "./DisclosureIcon.vue?vue&type=style&index=0&id=924aad52&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-924aad52"]])

export default __exports__